import { render, staticRenderFns } from "./citation.vue?vue&type=template&id=1b3c0724&scoped=true"
import script from "./citation.vue?vue&type=script&lang=js"
export * from "./citation.vue?vue&type=script&lang=js"
import style0 from "./citation.vue?vue&type=style&index=0&id=1b3c0724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c0724",
  null
  
)

export default component.exports